import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
const Root = (
  import.meta.env.VITE_CHECK_PRODUCTION ? (
    <App />
  ) : (
    <StrictMode>
      <App />
    </StrictMode>
  )
);
createRoot(document.getElementById('root')!).render(Root)
